import { deleteLastSubscriptionTime } from './deleteLastSubscriptionTime';
import { debug } from '../../../utils/DebugUtil';
import { getIsSubscriptionStale } from './getIsSubscriptionStale';

/**
 * Will unsubscribe from push notification if an active subscription is older than 24 hours
 * Returns a promise that resolves with true if a resubscribe is necessary or false if the
 * provided current subscription is still suitable
 */
export const removeSubscriptionIfStale = async subscription => {
  if (!subscription) {
    try {
      debug('no existing push subscription, clearing last subscribed time');
      // Edge case, may have subscribed today then unregistered the service worker in dev tools
      // since there's no subscription on THIS worker, clear the persisted time to allow a refresh
      await deleteLastSubscriptionTime();
    } catch (error) {
      debug('failed to delete last subscription time. Will proceed');
    }
    return true;
  }
  try {
    const shouldUnsubscribe = await getIsSubscriptionStale();
    if (shouldUnsubscribe) {
      await subscription.unsubscribe();
      debug('unsubscribed from previous push subscription');
    } else {
      debug('have active push subscription');
      return false;
    }
  } catch (error) {
    debug('failed to unsubscribe from previous push subscription. Will proceed', error);
  }
  return true;
};